export default class Authors extends Component {
  render() {
    const { hasBorderTop, hasMarginBottom } = this.props

    const Header = props => (
      <Text
        marginBottom={2}
        textTransform="uppercase"
        fontWeight={400}
        color="rgba(0, 0, 0, 0.5)"
        fontSize={10}
        {...props}
      />
    )

    return (
      <Surface
        gridColumn="screen"
        width="100%"
        style={{
          borderTop: hasBorderTop && "1px solid hsla(0, 0%, 0%, 0.1)",
          borderBottom: "1px solid hsla(0, 0%, 0%, 0.1)",
        }}
        alignSelf="center"
        alignItems="center"
        marginBottom={hasMarginBottom && 20}
        paddingY={20}
      >
        <Surface alignSelf="center" width={articleWidth}>
          <Surface flexFlow="row">
            <Surface>
              <Header>Authors</Header>
              <Text marginY={2} fontWeight={600}>
                Nick Cammarata
              </Text>
              <Text marginY={2} fontWeight={600}>
                Chris Olah
              </Text>
            </Surface>

            <Surface marginX={70}>
              <Header>Affiliations</Header>
              <Text marginY={2}>OpenAI</Text>
              <Text marginY={2}>OpenAI</Text>
            </Surface>

            <Surface>
              <Header>Published</Header>
              <Text marginY={2}>Not Yet</Text>
            </Surface>
          </Surface>
          <Surface
            border
            marginTop={10}
            paddingY={5}
            borderRadius={5}
            width={370}
            background="rgba(0, 0, 0, 0.01)"
            alignItems="center"
            justifyContent="center"
          >
            <Text size={400} fontWeight={500} opacity={0.6}>
              Authors are not finalized. This is just a placeholder.
            </Text>
          </Surface>
        </Surface>
      </Surface>
    )
  }
}
